import h from 'react-hyperscript';
import hh from 'hyperscript-helpers';
import R from 'ramda';
import Grid from '../Grid';
import Card from '../Card';
import HeroText from '../HeroText';
import Container from '../Container';
import Header from '../Header';
import Footer from '../Footer';
import faqs from './faqs.json';

import styles from './faq.css';

const { div } = hh(h);

const FAQ = (props) => {
    return div({className: styles.faq}, [
        h(Header),
        h(Container, {theme: 'five', size: 'big'}, [
            h(HeroText, 'Frequently Asked Questions')]),
        h(Container, {size: 'bigTop'}, [
            h(Grid, {
                children: R.map((faq) => h(Card, {theme: 'one', headerText: faq.question, bodyText: faq.answer}),
                                faqs)})]),
        h(Container, [h(Footer)])]);
};

export default FAQ;



/** WEBPACK FOOTER **
 ** ./src/FAQ/index.js
 **/